(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-category-hero"] && !Shopify.designMode) return;
  try {
    
  const initializeCategoryImageFollowers = (scope = document) => {
    scope.querySelectorAll('.collection-category-hero').forEach((section) => {
      if (section.dataset.categoryImageFollowerReady === 'true') return;

      const categories = section.querySelector('.collection-category-hero__categories');
      if (!categories) return;

      const mobileSelect = section.querySelector('[data-collection-category-select]');
      mobileSelect?.addEventListener('change', (event) => {
        const destination = event.currentTarget.value;
        if (destination) window.location.assign(destination);
      });

      section.dataset.categoryImageFollowerReady = 'true';
      let activeLink;

      const clearActiveLink = () => {
        activeLink?.removeAttribute('data-pointer-active');
        activeLink = undefined;
      };

      categories.addEventListener(
        'pointermove',
        (event) => {
          if (event.pointerType === 'touch' || !window.matchMedia('(min-width: 750px) and (pointer: fine)').matches) {
            clearActiveLink();
            return;
          }

          const link = event.target.closest('.collection-category-hero__category-link');
          if (!link || !categories.contains(link)) {
            clearActiveLink();
            return;
          }

          if (activeLink !== link) {
            clearActiveLink();
            activeLink = link;
            activeLink.setAttribute('data-pointer-active', 'true');
          }

          activeLink.style.setProperty('--category-pointer-x', `${event.clientX}px`);
          activeLink.style.setProperty('--category-pointer-y', `${event.clientY}px`);
        },
        { passive: true }
      );

      categories.addEventListener('pointerleave', clearActiveLink, { passive: true });
      categories.addEventListener('pointercancel', clearActiveLink, { passive: true });
    });
  };

  initializeCategoryImageFollowers();

  document.addEventListener('shopify:section:load', (event) => {
    initializeCategoryImageFollowers(event.target);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-category-showcase"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('product-category-showcase')) {
    class ProductCategoryShowcase extends HTMLElement {
      connectedCallback() {
        this.viewport = this.querySelector('[data-category-viewport]');
        this.grid = this.querySelector('.product-category-showcase__grid');
        this.nextButton = this.querySelector('[data-category-next]');

        if (!this.viewport || !this.grid || !this.nextButton) return;

        this.handleNext = this.handleNext.bind(this);
        this.updateOverflow = this.updateOverflow.bind(this);
        this.nextButton.addEventListener('click', this.handleNext);

        if ('ResizeObserver' in window) {
          this.resizeObserver = new ResizeObserver(this.updateOverflow);
          this.resizeObserver.observe(this.viewport);
          this.resizeObserver.observe(this.grid);
        }

        requestAnimationFrame(this.updateOverflow);
      }

      disconnectedCallback() {
        this.nextButton?.removeEventListener('click', this.handleNext);
        this.resizeObserver?.disconnect();
      }

      updateOverflow() {
        const hasOverflow = this.viewport.scrollWidth > this.viewport.clientWidth + 2;
        this.dataset.hasOverflow = String(hasOverflow);
        this.nextButton.hidden = !hasOverflow;
      }

      handleNext() {
        const firstCard = this.grid.querySelector('.product-category-showcase__card');
        if (!firstCard) return;

        const gap = parseFloat(getComputedStyle(this.grid).columnGap) || 0;
        const step = firstCard.getBoundingClientRect().width + gap;
        const maxScroll = this.viewport.scrollWidth - this.viewport.clientWidth;
        const nextPosition = this.viewport.scrollLeft >= maxScroll - 2
          ? 0
          : Math.min(this.viewport.scrollLeft + step, maxScroll);
        const behavior = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';

        this.viewport.scrollTo({ left: nextPosition, behavior });
      }
    }

    customElements.define('product-category-showcase', ProductCategoryShowcase);
  }

  } catch(e) { console.error(e); }
})();
})();
